import { ApiResourceMethod } from '@/api/api-requests-factory';
import {
  ProcessingModeratedTransactionManualFlow,
  ProcessingModeratedTransactionManualFlowPayload,
} from '@/models/payment/processing-moderated-transaction-manual-flow.model';

export class UpdateProcessingModeratedTransactionManualFlowRequest
  extends ApiResourceMethod<ProcessingModeratedTransactionManualFlow> {
  public perform(
    { whitelabelSlug, playerId, ...payload }: ProcessingModeratedTransactionManualFlowPayload,
  ): Promise<ProcessingModeratedTransactionManualFlow> {
    return this.performer.requestWithMapper({
      url: `${whitelabelSlug}/player/${playerId}/bpWlTransactionModerationInfoManualFlow`,
      data: { ...payload },
    });
  }
}
